export default "__VITE_ASSET__34b0575c__"